import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NotifMessageService } from 'app/core/services/notifmessage.service';

import { Subscription } from 'rxjs';
import { Items } from 'app/core/models/items';
import { MetaWalletReportingService } from 'app/core/services/meta-wallet-reporting.service';
import { PaymentMeansByPeriod } from 'app/core/models/paymentMeansByPeriod';
import { BaseComponent } from 'app/base/base.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cards-reports',
  templateUrl: './cards-reports.component.html',
  styleUrls: ['./cards-reports.component.css']
})
export class CardsReportsComponent extends BaseComponent implements OnInit {

  cardReportForm: FormGroup;
  cardStatusItems: Array<String> = Array<String>("ACTIVE", "INACTIVE");

  cardStatusSub: Subscription;
  cardReportPeriodSub: Subscription;
  subscription: Subscription;

  isLoading: boolean;
  period: number = 12;
  periodItems: Array<number> = Array<number>(3, 6, 12);
  cardsReport: Items<PaymentMeansByPeriod>;
  cardStatus: string;
  fromDate: Date;
  active: boolean = true;
  reportData: number[];
  reportLabel: string[];
  reportTitle: string;

  criteria = {
    active: this.active,
    windowBegin: this.getFromDate(this.period),
    windowEnd: new Date()
  };
  displayedColumns = ['month','year','paymentMeanCount'];

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private notifService: NotifMessageService,
    public router: Router,
    private metaWalletReportingService: MetaWalletReportingService) { super(router); }

  ngOnInit() {
    this.cardReportForm = this.formBuilder.group({
      cardStatus: new FormControl(this.cardStatusItems[0], Validators.required),
      period: new FormControl(this.period, Validators.required)
    });

    this.getNumberOfPmByPeriod();

    this.cardStatusSub = this.cardReportForm.get("cardStatus").valueChanges.subscribe(val => {
      if (this.isFormValid()) {
        this.active = this.isActive(val);
        this.criteria.active = this.active;
        this.criteria.windowBegin = this.getFromDate(this.period);
        this.getNumberOfPmByPeriod();
      }
    });

    this.cardReportPeriodSub = this.cardReportForm.get("period").valueChanges.subscribe(val => {
      if (this.isFormValid()) {
        this.period = val;
        this.criteria.active = this.active;
        this.criteria.windowBegin = this.getFromDate(val);
        this.getNumberOfPmByPeriod();
      }

    });
  }
  isFormValid(): boolean {
    if (this.cardReportForm.get("cardStatus").valid && this.cardReportForm.get("period").valid)
      return true;
    return false;
  }

  getNumberOfPmByPeriod(): void {
    this.reportTitle = this.translate.instant("CARDS_NUMBER_EVOLUTION");
    this.isLoading = true;
    this.metaWalletReportingService.getNumberOfPmByPeriod(this.criteria).subscribe(
      items => {
        this.cardsReport = items;
        this.reportLabel = items.map(items => this.getMonthName(items.month) + " " + items.year);
        this.reportData = items.map(items => items.paymentMeanCount);
        this.isLoading = false;
        if (items.empty) {
          this.notifService.notifyInfo('EMPTY_RESULT');
        }
      });
  }

  getMonthName(month: number): string {
    let monthName = this.monthMap.get(month);
    return this.translate.instant(monthName);
  }

  getFromDate(period: number): Date {
    this.fromDate = new Date();
    this.fromDate.setMonth(this.fromDate.getMonth() - period);
    return this.fromDate;
  }

  isActive(cardStatus): boolean {
    if (cardStatus == "ACTIVE")
      return true;
    return false;
  }

  date() {
    let frDateFormat = "dd MMM y";
    let usDateFormat = "MMM dd y";
    if (this.translate.currentLang == "fr_FR")
      return frDateFormat;
    else
      return usDateFormat;
  }

  locale() {
    if (this.translate.currentLang == "fr_FR")
      return "fr_FR";
    else
      return "en_US";
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.cardStatusSub) {
      this.cardStatusSub.unsubscribe();
    }
    if (this.cardStatusSub) {
      this.cardStatusSub.unsubscribe();
    }
  }


}
